import script from "./Kpp.vue?vue&type=script&setup=true&lang=js"
export * from "./Kpp.vue?vue&type=script&setup=true&lang=js"

import "./Kpp.vue?vue&type=style&index=0&id=18193b50&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18193b50"]])

export default __exports__